import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function ButtonSizes({onClick }) {
  return (
    <Box  sx={{ '& button': { m: 1, backgroundColor: '#E72929', color: 'white', textTransform: 'none' } }}>

      <div>
        <Button variant="contained" size="small" onClick={onClick}>
          Valider
        </Button>
      </div>
    </Box>
  );
}